import { Box, Stack, Typography } from '@mui/material';
import ResponsiveTooltip from '../../ResponsiveTooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../context/AuthContext';

interface TaxSettingsCardProps {}

const TaxSettingsCard: React.FC<TaxSettingsCardProps> = () => {
    const { t } = useTranslation();
    const { currentCtUser } = useAuth();

    return (
            <Stack spacing={2}>
                <Typography variant="h6" fontWeight="bold" fontSize="1.25rem">
                    {t('settings.tax.title')}
                </Typography>
                <Typography variant="body2" fontWeight="bold" fontSize="1rem">
                    {t('settings.tax.country')}: {t('settings.tax.values.germany')}
                </Typography>
                <Typography variant="body2" fontWeight="bold" fontSize="1rem">
                    {t('settings.tax.localCurrency')}: {currentCtUser?.currency || '-'}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body2" fontWeight="bold" fontSize="1rem">
                        {t('settings.tax.inventoryMethod')}: {t('settings.tax.values.fifo')}
                    </Typography>
                    <ResponsiveTooltip 
                        title={
                            <Box sx={{ p: 1.5 }}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                                    {t('settings.tax.tooltips.inventoryMethod')}
                                </Typography>
                            </Box>
                        }
                        arrow
                        placement="right"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    p: 0,
                                    bgcolor: (theme) => theme.palette.background.paper,
                                    color: (theme) => theme.palette.text.primary,
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    border: '1px solid',
                                    borderColor: (theme) => theme.palette.divider,
                                    borderRadius: 1,
                                    fontSize: '0.9rem',
                                    fontWeight: 'bold',
                                    '& .MuiTooltip-arrow': {
                                        color: (theme) => theme.palette.background.paper,
                                    }
                                },
                            },
                            popper: {
                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        p: 0,
                                    }
                                }
                            }
                        }}
                    >
                        <InfoOutlinedIcon 
                            sx={{
                                ml: 0.5,
                                fontSize: '1.1rem',
                                color: (theme) => theme.palette.text.secondary,
                                cursor: 'help',
                            }} 
                        />
                    </ResponsiveTooltip>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body2" fontWeight="bold" fontSize="1rem">
                        {t('settings.tax.costBasis')}: {t('settings.tax.values.perAccount')}
                    </Typography>
                    <ResponsiveTooltip 
                        title={
                            <Box sx={{ p: 1.5 }}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                                    {t('settings.tax.tooltips.costBasis')}
                                </Typography>
                            </Box>
                        }
                        arrow
                        placement="right"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    p: 0,
                                    bgcolor: (theme) => theme.palette.background.paper,
                                    color: (theme) => theme.palette.text.primary,
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    border: '1px solid',
                                    borderColor: (theme) => theme.palette.divider,
                                    borderRadius: 1,
                                    fontSize: '0.9rem',
                                    fontWeight: 'bold',
                                    '& .MuiTooltip-arrow': {
                                        color: (theme) => theme.palette.background.paper,
                                    }
                                },
                            },
                            popper: {
                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        p: 0,
                                    }
                                }
                            }
                        }}
                    >
                        <InfoOutlinedIcon 
                            sx={{
                                ml: 0.5,
                                fontSize: '1.1rem',
                                color: (theme) => theme.palette.text.secondary,
                                cursor: 'help',
                            }} 
                        />
                    </ResponsiveTooltip>
                </Box>
            </Stack>
    );
};

export default TaxSettingsCard;
